module.exports = {"id":"235675","name":"Mateo García","rating":"71","photo":"./data/images/photos/3/235675.png","club":{"name":"AD Alcorcón","logo":"./data/images/clubs/ADAlcorcon.png"},"positions":["MG","MD"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MateoGarcia0.json
// module id = 2851
// module chunks = 0